import React, { useState, useEffect } from "react";
import Header from "../../Header";
import { Multiselect } from "multiselect-react-dropdown";
import "./chat.css";
import { NavLink } from "react-router-dom";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import Select, { components } from "react-select";
import Async, { useAsync } from "react-select/async";
import Cookies from "js-cookie";

function AddFeedback(props) {
  const [formError, setFormError] = useState(false);
  const [feedback, setFeedback] = useState({});
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [userUUID, setUserUUID] = useState(0);
  const [transcriptId, setTranscriptId] = useState(props.match.params.id);
  const [userList, setUserList] = useState({});

  const [prodName, setprodName] = useState([]);
  const [podName, setpodName] = useState([]);
  const [featureName, setfeatureName] = useState([]);
  const [priority, setPriority] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [newIdeas, setNewIdeas] = useState([]);

  useEffect(() => {
    fetch("https://intranetapi.muvi.com/tattle/productList")
      .then((item) => {
        return item.json();
      })
      .then((data) => {
        setprodName(data);
      });

    fetch("https://intranetapi.muvi.com/tattle/podList")
      .then((item) => {
        return item.json();
      })
      .then((data) => {
        setpodName(data);
      });

    fetch("https://intranetapi.muvi.com/tattle/featureList")
      .then((item) => {
        return item.json();
      })
      .then((data) => {
        setfeatureName(data);
      });

    fetch(`${process.env.REACT_APP_CRM}/user-list`, {
      method: "POST",
    })
      .then((resp) => {
        return resp.json();
      })
      .then((data) => {
        if (data.code == 200) {
          setUserList(data.data);
        }
      });

    const resp = fetch(process.env.REACT_APP_CRM + "/live-chat/chat-details", {
      method: "post",
      body: JSON.stringify({ customer_tattle_uuid: transcriptId }),
    })
      .then((res) => res.json())
      .then((data) => {
        const { idea = [] } = data.data;
        if (data.code == 200) {
          setName(data.data.name);
          setNewIdeas(idea);
        }
      });
    fetch(process.env.REACT_APP_tattle_api + `/tattle/attributes`, {
      method: "POST",
      body: JSON.stringify({
        app_token: process.env.REACT_APP_tattle_token,
        attribute_set_key: "idea",
        show_on_form: true,
        attribute_status: true,
      }),
    })
      .then((resp) => {
        return resp.json();
      })
      .then((item) => {
        if (item.code == 200) {
          let datas = item.data
            .filter((i) => i.field == "priority")
            .map((s) => {
              return s.options;
            });
          setPriority(datas[0]);
        }
      });

    const user_uuid = Cookies.get("muvi_useruuid");
    setUserUUID(user_uuid);
  }, []);

  useEffect(() => {
    getUserUUID();
  }, [userList]);

  const getUserUUID = () => {
    const userdetails = decrypt(localStorage.getItem("encdata"), 0);
    const data = userList;
    const emp_id = parseInt(userdetails.user_id);
    let userUuid = null;

    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const user = data[key];
        if (user.emp_id === emp_id) {
          userUuid = user.user_uuid;
          break;
        }
      }
    }
    setUserUUID(userUuid);
  };

  const decrypt = (findresponse, flg) => {
    var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
    var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
    var res = flg ? findresponse.encdata : findresponse;
    var bytes = CryptoJS.AES.decrypt(res, key, {
      iv,
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plaintext);
  };

  function feebackFromHandler(e, val) {
    if (e == "title" && val.target.value.trim() !== 0) {
      setTitle(val.target.value.trim());
    } else if (e == "description" && val.target.value.trim() !== 0) {
      setDescription(val.target.value.trim());
    } else {
      setFormError(true);
      let formerror = { ...formError };
      formerror = {
        [e]: true,
      };
      setFormError(formerror);
    }
  }

  function submitFeedback() {
    console.log(feedback, 4354365756765);

    if (
      title.trim().length === 0 ||
      description.trim().length === 0 ||
      !feedback.hasOwnProperty("assign_to")
    ) {
      setFormError(true);
      let formerror = { ...formError };
      formerror = {
        title: true,
        description: true,
        assign_to: true,
      };
      setFormError(formerror);
      return false;
    } else {
      setFormError({ title: false, description: false, assign_to: false });
    }
    setSubmitting(true);
    const params = {
      app_token: process.env.REACT_APP_tattle_token,
      user_uuid: userUUID,
      attribute_set_key: "idea",
      attribute_set_type: 1,
      ...feedback,
      title,
      description,
      customer_name: name,
      feedback_source: ["6642d880eea827e1b1059221"],
      // live_chat: [transcriptId],
    };
    setFeedback({});
    setTitle("");
    setDescription("");
    fetch(process.env.REACT_APP_tattle_api + `/tattle/create`, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    })
      .then((res) => res.json())
      .then((dat) => {
        if (dat.code == 200) {
          let idea = dat.data.customer_tattle_uuid;
          const ideas = [...newIdeas];
          ideas.push(idea);
          let payload = {
            user_uuid: userUUID,
            attribute_set_key: "live_chat",
            app_token: process.env.REACT_APP_tattle_token,
            project: { idea: ideas },
            customer_tattle_uuid: +transcriptId,
          };
          fetch(process.env.REACT_APP_live_chat_update + `/live-chat/update`, {
            method: "post",
            body: JSON.stringify(payload),
          }).then((res) => {
            if (res.ok) {
              setSubmitting(false);
              props.history.push(`/chat/${transcriptId}`);
            }
          });
        }
      });
  }

  function updateMarketFeedback(market_feedback) {
    let payload = {
      ideas: market_feedback,
      transcript_id: transcriptId,
    };
    fetch(process.env.REACT_APP_CRM + `/live-chat/update-market-feedback`, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((item) => item.json())
      .then((resp) => {
        props.history.push(`/chats/${transcriptId}#Information`);
      });
  }
  function formHandler(e, val) {
    let formerror = { ...formError };
    console.log(val, 1212);
    if (e === "assign_to" || e === "priority") {
      setFeedback({
        ...feedback,
        [e]: val.value,
      });
      formerror = {
        ...formerror,
        [e]: false,
      };
      setFormError(formerror);
    } else {
      setFeedback({
        ...feedback,
        [e]: val.map((item) => item.value),
      });
    }

    console.log("formhandler", feedback);
    console.log("title", title);
    console.log("description", description);
  }

  const InputOption = ({
    getStyles,
    Icon,
    isDisabled,
    isFocused,
    isSelected,
    children,
    innerProps,
    ...rest
  }) => {
    // styles
    let bg = "transparent";
    if (isFocused) bg = "#f4f7fc";

    const style = {
      alignItems: "center",
      backgroundColor: bg,
      color: "inherit",
      display: "flex ",
    };

    // prop assignment
    const props = {
      ...innerProps,
      style,
    };

    return (
      <components.Option
        {...rest}
        isDisabled={isDisabled}
        isFocused={isFocused}
        isSelected={isSelected}
        getStyles={getStyles}
        innerProps={props}
      >
        <input
          type="checkbox"
          checked={isSelected}
          style={{ marginRight: "5px", marginTop: "0px" }}
        />
        {children}
      </components.Option>
    );
  };

  return (
    <React.Fragment>
      <div>
        <Header
          brecum_name="Live Chat Transcript"
          brecum_page="Live Chat Transcript"
        />
        <div class="right_col" role="main">
          <div class="intranet_body">
            <div class="title mob hidden-md"></div>
            <div class="title">
              <span>
                {" "}
                <NavLink to={`/chat/${transcriptId}`}>
                  {" "}
                  <i class="fa fa-arrow-left"></i>{" "}
                </NavLink>{" "}
                Add Idea (ID: {transcriptId})
              </span>
            </div>

            <div class="modal-body">
              <div class="row">
                <div class="col-md-12 form-group">
                  <label for="reward-title">
                    Title <span class="error-msg">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    name="title"
                    placeholder="Title"
                    onChange={(evt) => feebackFromHandler("title", evt)}
                  />
                  {formError.title && title.length === 0 && (
                    <label className="error-msg">Please fill the field</label>
                  )}
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 form-group">
                  <label for="reward-title">
                    Description <span class="error-msg">*</span>
                  </label>
                  <textarea
                    name="description"
                    class="form-control"
                    rows={3}
                    onChange={(evt) => feebackFromHandler("description", evt)}
                  ></textarea>
                  {formError.description && description.length === 0 && (
                    <label className="error-msg">Please fill the field</label>
                  )}
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 form-group">
                  <label for="reward-title">Assign To</label>{" "}
                  <span class="error-msg">*</span>{" "}
                  <Select
                    className="multi-select"
                    classNamePrefix="multi-select"
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    options={Object.keys(userList).map((item) => {
                      return {
                        label: userList[item].name,
                        value: userList[item].user_uuid,
                      };
                    })}
                    displayValue="label"
                    closeOnSelect={false}
                    onChange={(e) => formHandler("assign_to", e)}
                  />
                  {formError.assign_to &&
                    feedback["assign_to"] === undefined && (
                      <label className="error-msg">Please fill the field</label>
                    )}
                </div>
                <div class="col-md-6 form-group">
                  <label for="reward-title">Priority</label>
                  <Select
                    className="multi-select"
                    classNamePrefix="multi-select"
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    options={priority.map((item) => {
                      return { label: item.option_name, value: item._id };
                    })}
                    displayValue="label"
                    closeOnSelect={false}
                    onChange={(e) => formHandler("priority", e)}
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 form-group">
                  <label for="reward-title">Customer Name</label>
                  <input
                    type="text"
                    class="form-control"
                    name="reward_name"
                    placeholder="Customer Name"
                    value={name}
                    readOnly
                  />
                </div>
                <div class="col-md-6 form-group">
                  <label for="reward-title">POD</label>
                  <Select
                    isMulti
                    className="multi-select"
                    classNamePrefix="multi-select"
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    options={podName.map((item) => {
                      return { label: item.value, value: item.id };
                    })}
                    displayValue="label"
                    closeOnSelect={false}
                    onChange={(e) => formHandler("pod", e)}
                    components={{
                      Option: InputOption,
                    }}
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 form-group">
                  <label for="reward-title">Product</label>
                  <Select
                    isMulti
                    className="multi-select"
                    classNamePrefix="multi-select"
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    options={prodName.map((item) => {
                      return { label: item.value, value: item.id };
                    })}
                    displayValue="label"
                    closeOnSelect={false}
                    onChange={(e) => formHandler("product", e)}
                    components={{
                      Option: InputOption,
                    }}
                  />
                </div>
                <div class="col-md-6 form-group">
                  <label for="reward-title">Feature</label>
                  <Select
                    isMulti
                    className="multi-select"
                    classNamePrefix="multi-select"
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    options={featureName.map((item) => {
                      return { value: item.id, label: item.value };
                    })}
                    displayValue="label"
                    closeOnSelect={false}
                    onChange={(e) => formHandler("feature", e)}
                    components={{
                      Option: InputOption,
                    }}
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 form-group">
                  <button
                    type="submit"
                    name="add_employee"
                    id="add_employee"
                    class="btn btn-sky mob-btn"
                    onClick={() => submitFeedback()}
                    disabled={submitting ? "disabled" : ""}
                  >
                    Submit
                  </button>
                  <NavLink to={`/chat/${transcriptId}`}>
                    {" "}
                    <button className="btn btn-blue hidden-sm">Back</button>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default AddFeedback;



// WEBPACK FOOTER //
// ./src/components/chat/AddFeedback.js